module.exports = __webpack_public_path__ + "img/model_image_eng.86e45eaf.png";